import * as r from 'ramda';

export function isLoading(state, ns, id) {
    return r.pathOr(new Set(), ['loading', ns], state).has(id);
}
